<script>
import IconCard from '@/components/cards/IconCard.vue';
import InCellVisitService from '@/services/InCellVisitsService';

export default {
  name: 'InCellVisitsHome',
  components: { IconCard },
  data() {
    return {
      loading: true,
      approvedVisits: 0,
      awaitingConfirmationVisits: 0,
      requestedVisits: 0,
    };
  },
  mounted() {
    this.loading = false;
    this.getInCellVisitStats();
  },
  methods: {
    async getInCellVisitStats() {
      try {
        const { data } = await InCellVisitService.getInCellVisitStats();
        this.requestedVisits = data.requested;
        this.awaitingConfirmationVisits = data.awaitingConfirmation;
        this.approvedVisits = data.approved;
      } catch (e) {
        console.error('Error getting in-cell call stats: ', e);
      }
    },
  },
}
</script>

<template>
  <b-card>
    <loader v-if="loading" />
    <section v-else>
      <b-card-title>
        <b-btn
          class="float-right"
          variant="primary"
          :to="{ name: 'book-in-cell-visit' }"
        >
          Book In-Room Calls
        </b-btn>
        <h2>In-Room Calls</h2>
      </b-card-title>
      <b-row class="px-2 pt-2">
        <b-col cols="4">
          <icon-card
            :statistic="requestedVisits"
            color="primary"
            icon="CalendarIcon"
            route="requested-in-cell-visits"
            statistic-title="Requested Visits"
            tooltip="These are calls that need your approval"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            :statistic="awaitingConfirmationVisits"
            color="info"
            icon="CalendarIcon"
            route="awaiting-in-cell-visits"
            statistic-title="Awaiting Confirmation"
            tooltip="These are calls that you have booked and the visitor is waiting to accept"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            :statistic="approvedVisits"
            color="secondary"
            icon="CalendarIcon"
            route="approved-in-cell-visits"
            statistic-title="Approved Visits"
            tooltip="These are calls both you and the visitor have approved"
          />
        </b-col>
      </b-row>
      <b-row class="px-2 pt-1">
        <b-col cols="4">
          <icon-card
            tooltip="These are calls that are completed"
            route="completed-in-cell-visits"
            icon="CalendarIcon"
            color="success"
            statistic-title="Completed Visits"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            tooltip="These are calls that you or the visitor have cancelled"
            route="cancelled-in-cell-visits"
            icon="CalendarIcon"
            color="warning"
            statistic-title="Cancelled Visits"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            tooltip="These are calls that have been rejected by you"
            route="rejected-in-cell-visits"
            icon="CalendarIcon"
            color="danger"
            statistic-title="Rejected Visits"
          />
        </b-col>
      </b-row>
    </section>
  </b-card>
</template>
